import { Link, useLocation } from 'react-router-dom';
import './AdminLayout.css';

export default function AdminLayout({ children }) {
  const location = useLocation();

  const navItems = [
    {
      path: '/super-admin',
      icon: '🏢',
      label: 'Companies & Users',
      description: 'Manage all companies and users'
    },
    {
      path: '/super-admin/activity-log',
      icon: '📋',
      label: 'Activity Log',
      description: 'Audit trail of admin actions'
    }
  ];

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <div className="admin-logo">
          <h2>⚙️ Super Admin</h2>
          <p>Internal Tools</p>
        </div>

        <nav className="admin-nav">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <div className="nav-text">
                <div className="nav-label">{item.label}</div>
                <div className="nav-description">{item.description}</div>
              </div>
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <a href="/dashboard" className="btn-back-to-app">
            ← Back to Dashboard
          </a>
        </div>
      </div>

      <div className="admin-main">
        {children}
      </div>
    </div>
  );
}
